import { createEvent, createStore, sample } from 'effector';
import { createGate } from 'effector-react';

import { postSurveyAnswersFx } from 'shared/api';
import { notifyFromEffect } from 'shared/notifier';
import { SurveyForm } from 'entities/surveyForm';

export const SurveyFormModel = SurveyForm.factory.createModel();

export const SurveyModalGate = createGate();

export const showFinalContent = createEvent();

export const $isShowFinalContent = createStore(false).on(showFinalContent, (state) => !state);

sample({
  clock: postSurveyAnswersFx.doneData,
  target: showFinalContent,
});

notifyFromEffect({
  effect: postSurveyAnswersFx,
  $isActive: SurveyModalGate.status,
  isNeedRedirect: false,
});
